export enum StateModel {
	Approved = 'Approved',
	Rejected = 'Rejected'
}

export const IMPORTMSG = {
	CANDELETE:
		'There is an order with the same reference ID.  Do you want to import anyway and delete it?',
	CANDELETEMUILTIPLES:
		'There are existing orders with the same reference ID.  Do you want to import anyway and delete them?',
	CANNOTIMPORT: 'There is an order with the same reference ID and you can not duplicate it'
};
